const SSOLogo = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3991_39403)">
            <path d="M13.0341 0.464844H0.482422V12.5982H13.0341V0.464844Z" fill="#F8510C" stroke="white" />
            <path d="M13.0341 15.3984H0.482422V27.5318H13.0341V15.3984Z" fill="#00A3F4" stroke="white" />
            <path d="M27.5175 0.464844H14.9658V12.5982H27.5175V0.464844Z" fill="#7EBA00" stroke="white" />
            <path d="M27.5175 15.3984H14.9658V27.5318H27.5175V15.3984Z" fill="#FFBA00" stroke="white" />
        </g>
        <defs>
            <clipPath id="clip0_3991_39403">
                <rect width="28" height="28" fill="white" />
            </clipPath>
        </defs>
    </svg>);

export default SSOLogo;
